import { useNavigate, useParams } from 'react-router-dom'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { NewCompetencyModal } from 'modules/competencies/components/NewCompetencyModal'
import useAddCompetenciesToRole from 'modules/job_catalog/hooks/useAddCompetenciesToRole'

const Component = () => {
  const { id } = useParams<{ id: string }>()
  const roleId = String(id)
  const navigate = useNavigate()
  const { addCompetenciesToRole } = useAddCompetenciesToRole()

  if (!roleId) {
    // TODO: carefull when no previous path ( like when reloading)
    navigate(-1)
    return
  }
  const onSuccess = async (competencyId: string) => {
    track(trackingEvents.jobCatalog.jobRoleAddAndAssignCompetencySubmit)
    await addCompetenciesToRole(roleId, [competencyId])
    navigate(-1)
  }
  const onClose = () => {
    track(trackingEvents.jobCatalog.jobRoleAddAndAssignCompetencyCancel)
    navigate(-1)
  }

  return <NewCompetencyModal roleId={roleId} onSuccess={onSuccess} onClose={onClose} />
}

export default Component
